import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import { TermsModal } from '../app/TermsModal';
import { accountService, alertService, lockerService } from '../_services';
import { fetchWrapper, history } from '../_helpers';
import { renderOptions, chooseMap } from './NBMapFunctions';


import smallLockerSelect from "../assets/images/locker-select-small.png";
import largeLockerSelect from "../assets/images/locker-select-large.png";
import stdLockerSelect from "../assets/images/locker-select-standard.png";
import xlargeLockerSelect from "../assets/images/locker-select-x-large.png";

import surf_map from "../assets/images/surf-map.png";
import hillside_map from "../assets/images/hillside-map.png";
import wunder_map from "../assets/images/wunder-map.png";
import blast_map from "../assets/images/blast-map.png";
import tube_map from "../assets/images/tube-map.png";
import wave_map from "../assets/images/wave-map.png";

import { loadStripe } from '@stripe/stripe-js';

const imgs = {
  Small: smallLockerSelect,
  Large: largeLockerSelect,
  Standard: stdLockerSelect,
  Medium: stdLockerSelect,
  'X-Large': xlargeLockerSelect,
  none: ''
}

const area_imgs = {
  Blastenhoff: blast_map,
  Tubenbach: tube_map,
  Surfenburg: surf_map,
  Hillside: hillside_map,
  "Main Arcade": hillside_map,
  Wunder: wunder_map,
  Wave: wave_map,
  none: undefined,
  "":undefined
}


function NBReservation({ history }) {


  function min_date() {
    switch (minRentalDate) {
      case "TODAY":
        return moment().format("YYYY-MM-DD");
        break;
      case "TOMORROW":
        var tomorrow = moment().add(1, 'days');
        return moment(tomorrow).format("YYYY-MM-DD");
        break;
      default:
        return moment(minRentalDate).format("YYYY-MM-DD");
    }
  }

  function max_date() {
    if (moment(maxRentalDate, "YYYY-MM-DD", true).isValid()) {
      return moment(maxRentalDate).format("YYYY-MM-DD");
    } else {
      return moment().add(parseInt(maxRentalDate), 'days').format("YYYY-MM-DD");
    }
  }

  function preloadImage(url) {
    var img = new Image();
    img.src = url;
    //console.log("preloaded" + url);
  }

 
  const minRentalDate = accountService.configValue['minRentalDate'];
  const maxRentalDate = accountService.configValue['maxRentalDate'];

  //lockerAreas is a semicolon delimted list of area names
  const lockerAreas = accountService.configValue['lockerAreas'].split(";");
  const [showTerms, setShowTerms] = useState(false);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [options, setOptions] = useState([]);
  const [lockerSelectImage, setLockerSelectImage] = useState(imgs['X-Large']);

  const [areaSelect, setAreaSelect] = useState(2); //0 - Closed - 1:East only 2:Full park 
  const [areaSelectImage, setAreaSelectImage] = useState(undefined); 
  const [showAreaSelect, setShowAreaSelect] = useState(true);

  const [lockerArea, setLockerArea] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [soldOut, setSoldOut] = useState(false);
  const [parkClosed, setParkClosed] = useState(false);

  const [showLockerSelect, setShowLockerSelect] = useState( true );
  const [lockerType, setLockerType] = useState("X-Large");
 
  const [initVals, setInitVals] = useState({
    area: "",
    lockerType: "X-Large",
    startDate: min_date().toString(),
    acceptTerms: false
  });

  const stripeKey = accountService.configValue['stripePublicKey'];
  const stripePromise = loadStripe(stripeKey);
  const skipFee = (accountService.configValue['skipConvenienceCharge'] == 'true')

  const convenienceChargeCents = parseInt(accountService.configValue['convenienceChargeCents']);

  async function fetchData() {
    setShowLockerSelect(false);

    let areasid = chooseMap(date);
    if (areasid != 0) {
      setParkClosed(false);
    } else {      

      setParkClosed(true);
    }

    let tarea = (areasid != 0) ? lockerArea : "";

    setAreaSelect(areasid);

    if (lockerArea != "" && (typeof(lockerArea) != 'undefined')) {
      setAreaSelectImage(area_imgs[lockerArea]);
    } else {
      setAreaSelectImage(area_imgs["none"]);
    }

    console.log("SELECT IMAGE:" + area_imgs[lockerArea])
    
    const data = await lockerService.getLockerInventory(date, lockerArea);
    console.log(data);
    if (lockerArea != "") {
      setShowLockerSelect(true);
      var all_sold_out = true;
      for (var index = 0; index < data.length; index++) {
        if (data[index].availability > 0) {
          all_sold_out = false;
          break
        }
      }
      setSoldOut(all_sold_out);
    } 

    setOptions(options => data);
    var ltype = ""
    var ttyp = "";
    //on load, or when the lockerType is not available in the data, reset the size display image.
    if (imgs[lockerType] == "" || (data.length != 0 && (data.filter(item => (item.availability > 0)).filter(row => row.name == lockerType)).length == 0)) {
      var first_type = data.filter(item => (item.availability > 0)).sort((a, b) => (a.price > b.price) ? 1 : -1)[0]?.name;
      ttyp = imgs[first_type || 'none'];
      setLockerType(first_type);
      ltype = first_type;  

    } else {
      ttyp = imgs[lockerType];
      ltype = lockerType;
    }

    setLockerSelectImage(ttyp);
    setInitVals({
      area: tarea,
      lockerType: ltype,
      startDate: date,
      acceptTerms: false
    });

  }

  useEffect(() => {
    for (var key in imgs) {
      preloadImage(imgs[key]);
    }
    preloadImage(surf_map);
    preloadImage(hillside_map);
    preloadImage(wunder_map)
    preloadImage(blast_map);
    preloadImage(tube_map);
    preloadImage(wave_map);
  }, []); //preload images on first load.

  useEffect(() => {
    fetchData();
  }, [lockerArea, date]); //fetchData on date or area change
  //array arg is "dependencies" for useEffect - empty means run once on component mount
  //when this includes date, the select stops working so include date as well

  let validationSchema = Yup.object().shape({
    lockerType: Yup.string()
      .required('Choose a Locker Type'),
    startDate: Yup.date()
      .required('Reservation Date is required'),
    acceptTerms: Yup.bool()
      .oneOf([true], 'Agreeing to rental conditions is required')
  });

  async function stripe_redir(lockerType, reservationId) {

    const stripe = await stripePromise;

    // Call your backend to create the Checkout Session

    const response = await fetchWrapper.post('/create-checkout-session',
      {
        lockerType: lockerType,
        reservation_id: reservationId
      }
    );

    //const session = await response.json();
    const session = await response;

    // When the customer clicks on the button, redirect them to Checkout.
    const result = await stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
      alertService.error(result.error.message);
    }
  }

  function onSubmit(fields, { setStatus, setSubmitting }) {
    setStatus();
    accountService.addReservation(fields)
      .then((data) => {
        //alertService.info('Reservation Step 2: Payment');
        stripe_redir(fields.lockerType, data.id);
      })
      .catch(error => {
        setSubmitting(false);
        alertService.error(error);
      });

  }

  const handleClose = () => {
    setShowTerms(false);
  };
  const handleShow = () => {
    setShowTerms(true);
  };

  const handleSizeChange = (e) => {
    setLockerType(e.target.value);
    setLockerSelectImage(imgs[e.target.value] ? imgs[e.target.value] : imgs['none']);
  };
  const handleDateChange = (e) => {
    setDate(e.target.value);
    setInitVals({
      area: "",
      lockerType: lockerType,
      startDate: date,
      acceptTerms: false
    });
  };

  const handleAreaSelectChange = (e) => {
    console.log("CHANGING Area  to--" + e.target.value + "--");
    setAreaSelectImage(area_imgs[e.target.value]);
    setSelectedArea(e.target.value);
    console.log("CHANGED Area to" + area_imgs[e.target.value]);
  };

  const handleAreaChange = (e) => {
    console.log("SET Area to " + selectedArea);
    setShowAreaSelect(false);
    setLockerArea(selectedArea);
  };


  return (

    <div className="card m-3">
      <Formik enableReinitialize={true} initialValues={initVals} validationSchema={validationSchema} onSubmit={onSubmit} >
        {({ errors, touched, isSubmitting, handleChange }) => (
          <Form>
            <div className="card-header">
              <h1 className="bold-tx">Rent a Locker</h1>
              <h5 className="mar-bot-0">Select Date, Area, and Size:</h5>
            </div>
            <div className="card-body">
              {showAreaSelect && 
                <>
                <div className="form-row">
                  <div className="form-group col-6">
                    <label>Select Date and Area:</label>
                    <Field
                      onChange={(e) => { handleChange(e); handleDateChange(e, this); }}
                      name="startDate" max={max_date()} min={min_date()} type="date" className={'form-control' + (errors.startDate && touched.startDate ? ' is-invalid' : '')} />
                    <ErrorMessage name="startDate" component="div" className="invalid-feedback" />
                  </div>
                </div>
                 { !parkClosed &&
                  <>
                    <div className="form-row">
                      <div className="form-group col-6">
                        <label>Select Area</label>
                        <Field as="select"
                          name="Area"
                          onChange={(e) => { handleChange(e); handleAreaSelectChange(e, this); }}
                          className={'form-control' + (errors.area && touched.area ? ' is-invalid' : '')} >
                          <option key={'default'} value={""}>Select Area . . .</option>
                          { renderOptions(areaSelect, lockerAreas) }
                        </Field>
                        <ErrorMessage name="Area" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                    {(typeof (areaSelectImage) != "undefined") && (!parkClosed) &&
                      <>
                        <div className="form-row">
                          <div className="form-group">
                            <img className="locker-select" src={areaSelectImage} />
                          </div>
                        </div>
                        <button type="submit" onClick={(e) => { handleAreaChange(e, this); }} disabled={isSubmitting} className="btn btn-primary">
                          Choose this Area
                      </button>
                      </>
                    }
                  </>
                }
                </>
              }
              

            {(showLockerSelect && !soldOut) ?
              (
                  <>
                    <div className="form-row">
                      <div className="form-group col-6">
                        <label>Date:{date}<br/>Location:{lockerArea}</label>
                      </div>
                    </div>

                  <div className="form-row">

                    <div className="form-group col-6">
                      <label>Select Size</label>
                      <Field as="select"
                        name="lockerType"
                        onChange={(e) => { handleChange(e); handleSizeChange(e, this); }}
                        className={'form-control' + (errors.lockerType && touched.lockerType ? ' is-invalid' : '')} >
                        {
                            options.filter(item => (item.availability > 0))
                            .sort((a, b) => (a.price > b.price) ? 1 : -1)
                            .map((option) => {
                                if (skipFee) {
                                    return <option key={option.name} value={option.name}> {option.name}    -    ${(((option.price * 100)) / 100)}</option>
                                }
                                else {
                                    return <option key={option.name} value={option.name}> {option.name}    -    ${(((option.price * 100) + convenienceChargeCents) / 100)}</option>
                                }
                            }

                            )
                        }
                      </Field>
                      <ErrorMessage name="lockerType" component="div" className="invalid-feedback" />
                    </div>

                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <img className="locker-select" src={lockerSelectImage} />
                    </div>
                  </div>
         

                  <div className="form-row rent-agree-marg">
                    <div className="form-group form-check col-6" style={{ 'paddingLeft': 30 + 'px', 'paddingRight': '0' }} >
                      <Field type="checkbox" name="acceptTerms" id="acceptTerms" className={'form-check-input ' + (errors.acceptTerms && touched.acceptTerms ? ' is-invalid' : '')} />
                      <label htmlFor="acceptTerms" className="form-check-label">I agree to the terms of the <Link to="#" onClick={handleShow} >Rental Agreement.</Link>
                        <br />
                                                All sales final, no refunds.
                                                </label>
                      <ErrorMessage name="acceptTerms" component="div" className="invalid-feedback" />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <button id="toPayment" type="submit" disabled={isSubmitting} className="btn btn-primary">
                        {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                Step 2 - Payment
                            </button>
                    </div>
                  </div>
                </>
              )
              :
                ((!showLockerSelect ) ? (
                <>

                </>
              ) :
                (
                  <>
                    <div className="form-row">
                      <div className="form-group">
                        <p> This area is currently sold out. Please try a different date or try again later. </p>
                      </div>
                    </div>
                  </>
                )
              )
            }
            </div>

            { parkClosed && 
              <div className="form-row">
                <div className="form-group">
                  <p> The park is closed on this date. Please try a different date. </p>
                </div>
              </div>
            }

            <div>
              <h3 className="card-header cust-footer">
                <Link to="login" className="btn btn-link">Cancel</Link>
              </h3>
            </div>
          </Form>
        )}
      </Formik>
      <TermsModal show={showTerms} onHide={handleClose} />
    </div>

  );

}


export { NBReservation }; 